import React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';
import Typography, { TypographyProps } from '@material-ui/core/Typography';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

interface Props {
  typographyProps?: TypographyProps;
  gridProps?: GridProps;
  noMargin?: boolean;
  label?: boolean;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    gridSubtitle: (props: Partial<Props>) => ({
      paddingBottom: props.label ? 0 : theme.spacing(2),
      marginTop: props.noMargin || props.label ? 0 : theme.spacing(2),
      '& p': { fontSize: props.label ? '14px' : undefined, fontWeight: props.label ? 'bold' : undefined },
    }),
  }),
);

const GridSubtitle: React.FC<Props> = ({ children, typographyProps, gridProps, noMargin, label }) => {
  const classes = useStyles({ noMargin, label });
  return (
    <Grid item xs={12} className={classes.gridSubtitle} {...gridProps}>
      <Typography {...typographyProps}>{children}</Typography>
    </Grid>
  );
};

export default GridSubtitle;
